import React from 'react';
import { motion } from 'framer-motion';
interface PricingProps {
  title?: string;
}
export function Pricing({
  title = 'ELEGÍ TU PACK'
}: PricingProps) {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-161">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-4xl md:text-5xl font-black text-center mb-16" data-id="element-162">
        {title}
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-163">
        {/* Basic Pack */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-green/20 rounded-3xl p-8 flex flex-col h-full" data-id="element-164">
          <div className="text-2xl font-black mb-2 flex items-center gap-2" data-id="element-165">
            <span data-id="element-166">📘</span> SUPERPACK ABDOMEN PLANO
          </div>
          <p className="text-gray-400 mb-8 font-medium" data-id="element-167">6 Tomos + 6 Bonos</p>

          <div className="mb-8 flex-grow" data-id="element-168">
            <div className="text-gray-500 line-through text-xl mb-1" data-id="element-169">
              ~~$49.000~~
            </div>
            <div className="text-5xl font-black text-white" data-id="element-170">
              $14.900{' '}
              <span className="text-xl text-gray-400 font-bold" data-id="element-171">ARS</span>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-darker border-2 border-brand-green text-brand-green hover:bg-brand-green hover:text-brand-darker font-black text-lg py-4 rounded-xl transition-colors" data-id="element-172">
            → QUIERO MI SUPERPACK AHORA
          </motion.button>
        </motion.div>

        {/* Premium Pack */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border-2 border-brand-green rounded-3xl p-8 flex flex-col h-full relative shadow-[0_0_50px_rgba(16,185,129,0.15)] md:scale-105 z-10" data-id="element-173">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-darker font-black text-sm px-4 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-174">
            MÁS ELEGIDO
          </div>

          <div className="text-2xl font-black mb-2 flex items-center gap-2" data-id="element-175">
            <span data-id="element-176">💎</span> COMBO DIAMANTE ⭐
          </div>
          <p className="text-gray-300 mb-2 font-bold" data-id="element-177">
            6 Tomos + 6 Bonos + Método Cuerpo Fit en Casa
          </p>
          <p className="text-brand-green/80 text-sm mb-8 font-medium" data-id="element-178">
            Tonificá brazos, glúteos y piernas después del abdomen
          </p>

          <div className="mb-8 flex-grow" data-id="element-179">
            <div className="text-gray-500 line-through text-xl mb-1" data-id="element-180">
              ~~$69.000~~
            </div>
            <div className="text-5xl font-black text-brand-green" data-id="element-181">
              $19.900{' '}
              <span className="text-xl text-brand-green/60 font-bold" data-id="element-182">ARS</span>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-green hover:bg-emerald-400 text-brand-darker font-black text-lg py-4 rounded-xl shadow-[0_0_20px_rgba(16,185,129,0.4)] transition-colors" data-id="element-183">
            → QUIERO EL COMBO DIAMANTE
          </motion.button>
        </motion.div>
      </div>
    </section>;
}